const warn = (issue, jqXHR) => {
	console.warn(`Invalid response to AJAX submission (${issue}):`, jqXHR)
	gae('jsWarning', `invalidAjaxResponse-${issue}`)
}

$(function(){
	if (typeof $.fn.dropdown === "function")
		$('.dropdown-toggle').dropdown();
	$("input.focus").focus();

	$('.ajax-submission').submit(function (e) {
		e.preventDefault();
		e.stopImmediatePropagation();
		var form = $(this);
		var url = form.attr("action");
		var method = form.attr("method");
		var data = {};
		$(':input', form).each(function(){
			var el = $(this);
			data[el.attr('name')] = el.val();
			el.next('.help-block').html("");
			$(el.parents('.control-group')[0]).removeClass('error');
		});
		$.ajax({
			type: method,
			url: url,
			data: data,
			dataType: 'json',
			xhrFields: { withCredentials: true },
			complete: function(jqXHR) {
				if (jqXHR) {
					if (jqXHR.responseText) {
						if (jqXHR.responseText !== '') {
							var json = JSON.parse(jqXHR.responseText);
							if (json.redirect) {
								window.location = url.replace(/(https?:\/\/[^/]+).*/, "$1"+json.redirect)
							} else if (json.redirect_full) {
								window.location = json.redirect_full;
							}

							if (json.error || jqXHR.status == 422) {
								let msg = '';
								if (typeof json.error == 'string') {
									var el = $(':input', form).first();
									el.next('.help-block').html(json.error);
									$(el.parents('.control-group')[0]).addClass('error');
									msg = json.error;
								} else if (typeof json.error == 'object') {
									$(':input', form).each(function(){
										var el = $(this);
										var name = el.attr('name');
										if (json.error[name]) {
											el.parent().find('.help-block').html(json.error[name]);
											$(el.parents('.control-group')[0]).addClass('error');
										}
									});
									for (var prop in json.error)
										msg += json.error[prop] + '<br>';
								}
								var el = $('#alert-msg', form).first();
								el.addClass('alert alert-error');
								el.html(msg);
								$(form).trigger('errorCallback', json, jqXHR);
							} else {
								if (json.success) {
									if (typeof json.success == 'string') {
										var el = $('#alert-msg', form).first();
										el.addClass('alert alert-success');
										el.removeClass('alert-error');
										el.html(json.success);
									}
								}
								$(form).trigger('successCallback', json, jqXHR);
							}
						} else { warn('emptyResponseText', jqXHR) }
					} else { warn('noResponseText', jqXHR) }
				} else { warn('noResponseObject', jqXHR) }
			},
		});

		return false;
	});
});
